import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import Image from "components/elements/image"
import RichText from "components/elements/richText"
import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React from "react"
import "./contact-jumpstart-cta-v2.scss"

const ContactJumpstartCtaV2 = ({
  contactCtaText,
  ctaButton,
  jumpstartCtaHeading,
  phoneNumber,
  photo,
  text,
}) => {
  return (
    <section className="contact-jumpstart-cta-v2">
      <div className="container-v2">
        <div className="contact-jumpstart-cta-v2--content-wrapper">
          <div className="contact-jumpstart-cta-v2--content">
            <div className="contact-jumpstart-cta-v2--content-header">
              {jumpstartCtaHeading?.heading && (
                <h2 className="contact-jumpstart-cta-v2--heading">
                  <TextLockupV2>{jumpstartCtaHeading.heading}</TextLockupV2>
                </h2>
              )}
              {text?.childrenMarkdownRemark?.[0]?.html && (
                <div
                  className="contact-jumpstart-cta-v2--text"
                  dangerouslySetInnerHTML={{
                    __html: text.childrenMarkdownRemark[0].html,
                  }}
                />
              )}
            </div>

            {phoneNumber && contactCtaText.json && (
              <div className="contact-jumpstart-cta-v2--contact-wrapper">
                <svg
                  aria-hidden="true"
                  fill="none"
                  height="57"
                  viewBox="0 0 59 57"
                  width="59"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    fill="#e1efff"
                    height="55.629"
                    rx="27.814"
                    width="58.719"
                    y=".946"
                  />
                  <path
                    d="m39.784 33.49-3.712-.423a2.91 2.91 0 0 0-2.397.833l-2.689 2.689a22 22 0 0 1-9.631-9.631l2.704-2.704a2.91 2.91 0 0 0 .833-2.397l-.424-3.683a2.925 2.925 0 0 0-2.908-2.587H19.03c-1.651 0-3.025 1.374-2.923 3.026.775 12.48 10.757 22.448 23.223 23.223 1.652.102 3.025-1.272 3.025-2.923v-2.529c.015-1.476-1.096-2.718-2.572-2.894"
                    fill="#122f4e"
                  />
                </svg>
                {contactCtaText.json && (
                  <div className="contact-jumpstart-cta-v2--contact-cta">
                    <RichText
                      className=""
                      richText={contactCtaText}
                      textStyle="full"
                    />
                  </div>
                )}
                {phoneNumber && (
                  <p className="contact-jumpstart-cta-v2--phone-number">
                    <ButtonV2
                      accessibilityLabel={`Call ${phoneNumber}`}
                      className="btn-v2 btn-v2--primary-blue btn-v2--small"
                      href={`tel:${phoneNumber}`}
                      showArrow={false}
                      text={"Call Now"}
                    />
                  </p>
                )}
              </div>
            )}
            {ctaButton && ctaButton?.path && ctaButton?.text && (
              <p className="contact-jumpstart-cta-v2--cta-button">
                <ButtonV2
                  accessibilityLabel={ctaButton.accessibilityLabel}
                  className={getButtonClasses(
                    ctaButton.buttonStyle,
                    ctaButton.buttonSize
                  )}
                  href={ctaButton.path}
                  key={ctaButton.id}
                  showArrow={ctaButton.showArrow === "Yes" ? true : false}
                  text={ctaButton.text}
                />
              </p>
            )}
          </div>
          {photo?.fluid && (
            <div className="contact-jumpstart-cta-v2--image">
              <Image
                alt={jumpstartCtaHeading?.heading || ""}
                className=""
                image={photo.fluid}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

ContactJumpstartCtaV2.propTypes = {
  contactCtaText: PropTypes.object.isRequired,
  ctaButton: PropTypes.object.isRequired,
  jumpstartCtaHeading: PropTypes.object.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  photo: PropTypes.object.isRequired,
  text: PropTypes.object.isRequired,
}

export default ContactJumpstartCtaV2
